import type { PermissionSelector } from "@/hooks/usePermission";

export const canEditOwnNotificationSettings: PermissionSelector = (x) => x.isAdmin;
